/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayConnectionDtoSchema = z.object({
  pingMs: z.number().nullish(),
  pingMaxMs: z.number().nullish(),
  disconnectSeconds: z.number().nullish(),
  disconnectShare: z.number().nullish(),
});
